import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { queryKeysClient } from 'common/clients/query-key.client.ts';
import { queryClient } from 'common/clients/query.client.ts';
import { EQueryKeys } from 'common/enums/query-keys.enums.ts';
import { EUrlQueryParams } from 'common/enums/url-query-params.enums.ts';
import { captureError, IError } from 'common/utils/error.utils.ts';
import { ITransactionDataRes } from 'domains/transaction/interfaces/transaction.interfaces.ts';
import { ITransactionPageLoaderData } from 'pages/transaction/interfaces/transaction.interfaces.ts';
import { ROUTES_MAPPING } from 'navigation/constants/route.constants.ts';

export const transactionPageLoader = async (
  { request }: LoaderFunctionArgs
): Promise<ITransactionPageLoaderData | Response> => {
  try {
    const reqOptions = {
      from: request.url,
    };
    const idQueryParamValue = new URL(request.url).searchParams.get(EUrlQueryParams.Id) ?? '';

    if (!idQueryParamValue) {
      return redirect(ROUTES_MAPPING.NO_MATCH);
    }

    const transactionDataQuery = queryKeysClient[EQueryKeys.TransactionKeys].getTransactionData({
      sep24GUID: idQueryParamValue,
      reqOptions,
    });
    const transactionData: ITransactionDataRes = await queryClient.fetchQuery(transactionDataQuery);

    return {
      transactionData,
      idQueryParamValue,
    };
  } catch (e: unknown) {
    const error = e as {
      response: {
        status: number;
      }
    };

    captureError(error as IError);

    return {
      transactionData: undefined,
      idQueryParamValue: '',
    };
  }
};
